import React, {createContext, useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {
  getShumaReasons,
  getBanks,
  getShumaPropertyTypes,
  getLoanTypes,
  getShumaTypesList,
  getLoanSubTypes,
  getShumaMuzminIdentityTypes,
} from './actions/decisionTreeOptionsActions';
import Spinner from "../Spinner";

const DecisionTreeOptionsContext = createContext('');

export function useDecisionTreeOptionsContext() {
  return useContext(DecisionTreeOptionsContext);
}

export function DecisionTreeOptionsContextProvider({children}) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const {reasons, banks, propertyTypes, loanTypes, loanSubTypes, shumaMazminIdentities} = useSelector(
    (state) => ({
      reasons: state.decisionTreeOptionsReducer.reasons,
      banks: state.decisionTreeOptionsReducer.banks,
      propertyTypes: state.decisionTreeOptionsReducer.propertyTypes,
      loanTypes: state.decisionTreeOptionsReducer.loanTypes,
      loanSubTypes: state.decisionTreeOptionsReducer.loanSubTypes,
      shumaMazminIdentities: state.decisionTreeOptionsReducer.shumaMazminIdentities,
    }),
    shallowEqual
  );

  const getOptions = async () => {
    if (!reasons || reasons?.length === 0) {
      await dispatch(getShumaReasons());
    }
    if (!banks || banks?.length === 0) {
      await dispatch(getBanks());
    }
    if (!propertyTypes || propertyTypes?.length === 0) {
      await dispatch(getShumaPropertyTypes());
    }
    if (!loanTypes || loanTypes?.length === 0) {
      await dispatch(getLoanTypes());
    }
    if (!loanSubTypes || loanSubTypes?.length === 0) {
      await dispatch(getLoanSubTypes());
    }
    if (!shumaMazminIdentities || shumaMazminIdentities?.length === 0) {
      await dispatch(getShumaMuzminIdentityTypes());
    }
  };

  useEffect(() => {
    setLoading(true);
    getOptions()
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const value = {
    getOptions,
    reasons,
    banks,
    propertyTypes,
    loanTypes,
    loanSubTypes,
    shumaMazminIdentities
  };

  return loading ? <Spinner/> : (
    <DecisionTreeOptionsContext.Provider value={value}>
      {children}
    </DecisionTreeOptionsContext.Provider>
  );
}

const DecisionTreeShumaTypesOptionsContext = createContext('');

export function useDecisionTreeShumaTypesOptionsContext() {
  return useContext(DecisionTreeShumaTypesOptionsContext);
}

export function DecisionTreeShumaTypesOptionsContextProvider({children}) {
  const [shumaTypes, setShumaTypes] = useState([]);

  const updateShumaTypes = async (shumaReasonID) => {
    if (shumaReasonID) {
      let list = await getShumaTypesList(shumaReasonID)
      setShumaTypes(list);
    }
  };

  const value = {
    shumaTypes,
    updateShumaTypes,
  };

  return (
    <DecisionTreeShumaTypesOptionsContext.Provider value={value}>
      {children}
    </DecisionTreeShumaTypesOptionsContext.Provider>
  );
}

DecisionTreeOptionsContextProvider.propTypes = {
  children: PropTypes.node,
};
